import { Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';

import { useLandingPage } from 'src/app/pages/search/shared/hooks';

export const HeaderTitle: React.FC = () => {
	const {
		data: { showLandingPage },
	} = useLandingPage();

	return (
		<div className={showLandingPage ? 'container pb-6' : 'hidden'}>
			<Text
				as="h1"
				variant="display"
				size="medium"
				className="mb-3 text-left md:text-center"
				data-qa="search-landing-heading"
			>
				<Translate value="corgi.search.title" />
			</Text>
			<Text as="p" size="x-large" fontWeight="light" className="mb-3 hidden text-center md:block">
				<Translate value="corgi.search.subtitle" />
			</Text>
		</div>
	);
};
